import { useEffect, useState } from "react";
import Loader from "../../components/loader";
import NoRecord from "../../components/NoRecord";
import PanelLayout from "../../layout/PanelLayout";
import { useDispatch, useSelector } from "react-redux";
import AssetCard from "../../components/pages/AssetCard";
import { fetchHomeAssets } from "../../redux/actions/assetAction";
import useDebounce from "../../components/hooks/useDebounce";
import { tabs } from "../../utils/pip";
import CategoryDropdown from "../../components/CategoryDropdown";

const AllAssets = () => {
  const dispatch = useDispatch();
  const [searchFilter, setSearchFilter] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const debouncedSearch = useDebounce(searchFilter, 500);
    const [showHomeSearch, setShowHomeSearch] = useState(true);
    const [activeTab, setActiveTab] = useState(tabs[0]?.lable);
  const { isLoading, assetList, assetCategoryList } = useSelector(
    (state) => state.assetReducer,
  );

  useEffect(() => {
    dispatch(
      fetchHomeAssets({
        search: debouncedSearch || "",
        categoryId: categoryId || "",
      }),
    );
  }, [categoryId, debouncedSearch, dispatch]);

      useEffect(() => {
        const handleScroll = () => {
          setShowHomeSearch(window.scrollY <= 390);
        };
    
        handleScroll();
        window.addEventListener("scroll", handleScroll);
    
        return () => window.removeEventListener("scroll", handleScroll);
      }, []);

  const handleSearch = () => {
    dispatch(
      fetchHomeAssets({
        search: searchFilter || "",
        categoryId: categoryId || "",
      }),
    );
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <PanelLayout
      categoryId={categoryId}
      searchFilter={searchFilter}
      assetCategoryList={assetCategoryList}
      onCategoryChange={setCategoryId}
      onSearchChange={setSearchFilter}
      onSearch={handleSearch}
      onClearSearch={() => setSearchFilter("")}
    >
      <section class="ct_home_banner">
        <div class="container">
          <div class="row align-items-center ">
            <div class="col-xl-7">
              <div class="ct_banner_title">
                <h2 class="ct_switzer_bold  ct_fs_44 ">
                  Manage Your Assets Securely
                </h2>

                <div
                  className={`ct_search_filter_main mt-0 ${showHomeSearch ? "" : "ct_opacity_none"}`}
                >
                  <div class="ct_banner_search_filters">
                    <CategoryDropdown
                      value={categoryId}
                      options={assetCategoryList}
                      onChange={setCategoryId}
                      className="ct_select_w_177 ct_w_100_575"
                      buttonClassName="ct_input border-0 opacity-75"
                      style={{ backgroundColor: "transparent", height: "60px" }}
                    />
                    <div class="position-relative ct_search">
                      <input
                        type="text"
                        value={searchFilter}
                        onChange={(e) => setSearchFilter(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSearch();
                          }
                        }}
                        class="form-control ct_input"
                        style={{
                          boxShadow: "0px 0px 9px 0px #00000040",
                          height: "60px",
                          paddingRight: "90px",
                        }}
                        placeholder="Search assets"
                      />
                      <button
                        type="button"
                        className="text-white border-0 rounded bg-danger ct_show_eye px-3 py-2"
                        style={{ right: "10px" }}
                        onClick={() => setSearchFilter("")}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 ps-xl-4 d-none d-xl-block">
              <div className="ct_home_banner_side_img">
                <img src="/assets/img/locked_banner_img.png" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mt-5">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between mb-0">
            <div>
              <h5 class="ct_fs_32 ct_fw_600 mb-0 ct_switzer_bold">
                All Assets
                {assetList?.length > 0 && <>({assetList?.length || 0})</>}
              </h5>
            </div>
          </div>
          <div className="ct_assets_data ct_custom_scroll pb-4">
            <div class="row ">
              {assetList?.length > 0 ? (
                assetList?.map((item, index) => (
                  <AssetCard
                    data={
                      item
                      //   {
                      //   promote: 1,
                      //   AssetImages: [
                      //     { image_url: "/assets/img/assets_1.png" },
                      //   ],
                      //   id: index + 1,
                      //   latitude: "",
                      //   longitude: "",
                      //   lock: index % 2 == 0 ? 1 : 0,
                      //   UIC: "6568520",
                      //   AssetName: "iPhone 15",
                      //   isStolen: index % 2 == 0 ? true : false,
                      //   AssetDetails:
                      //     "This property is not available for sale. Kindly...",
                      // }
                    }
                  />
                ))
              ) : (
                <NoRecord />
              )}
            </div>
          </div>
        </div>
      </section>
    </PanelLayout>
  );
};

export default AllAssets;
